export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // Dental Career Box
    const careerButtons = document.querySelectorAll('.career-button');
    const careerSections = document.querySelectorAll('.career-section');
    const careerSectionsBox = document.querySelector('.career-sections');

    const careerEventHandler = (e, target) => {
      e.preventDefault();

      careerSections.forEach((careerSection) => {
        careerSection.classList.remove('career-section-enabled');

        if (target === careerSection.dataset.careerSection) {
          careerSection.classList.add('career-section-enabled');
        }
      });

    }

    careerButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        careerEventHandler(e, button.dataset.careerSection);
        careerButtons.forEach((button) => {
          button.classList.remove('career-button-active');
        });
        button.classList.add('career-button-active');
        careerSectionsBox.classList.add('career-sections-active');
      });
    });

    // Custom Footer Nav Jumps
    const areaId = window.location.href.split('#')[1];
    const areaSelected = document.getElementById(`dentists-${areaId}`);

    if (areaId !== undefined && areaSelected !== null) {
      areaSelected.scrollIntoView();
      areaSelected.click();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/dentists.js